module.exports = "https://thumbor.subcdn.com/imageView2/minio-activity/aha-browser/google-play-mobile.png";